import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { ASCIImaxLength } from '@app/global-constants';
import { ModalBase } from '@components/modal/modal';
import { NotificationService } from '@components/notification/notification.service';
import { ServerSideSearchSelectDataSource } from '@components/select/server-side-search-select.component';
import {
  EdytujGrupeOdbiorcowRequest,
  GrupaOdbiorcowDto,
  StworzGrupeOdbiorcowRequest,
} from '@interfaces/komunikacja/grupa-odbiorcow.interface';
import { UzytkownikDto, UzytkownikDtoQueryParams } from '@interfaces/komunikacja/komunikacja.interface';
import { PaginatedData } from '@interfaces/response.interface';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GrupyOdbiorcowService } from '@services/api/komunikacja/grupy-odbiorcow.service';
import { KomunikacjaService } from '@services/api/komunikacja/komunikacja.service';
import { finalize, map, pipe } from 'rxjs';

@Component({
  templateUrl: './grupa-odbiorcow-form.component.html',
})
export class GrupaOdbiorcowFormComponent extends ModalBase implements OnInit {
  uzytkownicySource: ServerSideSearchSelectDataSource<KomunikacjaService, UzytkownikDto, UzytkownikDtoQueryParams> = {
    dataService: this.komunikacjaService,
    getRecords: this.komunikacjaService.getUzytkownicy,
    searchField: 'search',
    recordsOperations: pipe(
      map((res: PaginatedData<UzytkownikDto>) => ({
        ...res,
        data: res.data.map((user: UzytkownikDto) => ({
          ...user,
          nazwa: `${user.nazwisko} ${user.imie}`,
        })),
      })),
    ),
  };
  override recordData: GrupaOdbiorcowDto;
  readonly maksDlugoscNazwyGrupyOdbiorcow = ASCIImaxLength;

  constructor(
    override readonly activeModal: NgbActiveModal,
    protected override readonly fb: UntypedFormBuilder,
    private readonly grupyOdbiorcowService: GrupyOdbiorcowService,
    private readonly komunikacjaService: KomunikacjaService,
    private readonly notificationService: NotificationService,
  ) {
    super(activeModal);
    this.form = this.fb.group({
      nazwa: [null, [Validators.required, Validators.maxLength(this.maksDlugoscNazwyGrupyOdbiorcow)]],
      odbiorcaIds: [null, [Validators.required]],
    });
  }

  ngOnInit(): void {
    if (this.recordData) {
      this.title = $localize`Edytowanie nazwy grupy odbiorców`;
      this.form.patchValue(this.recordData);
      this.form.controls.odbiorcaIds.disable();
    } else {
      this.title = $localize`Tworzenie grupy odbiorców`;
    }
  }

  submit = (): void => {
    this.isSaving = true;
    if (this.recordData) {
      this.updateNazwaGrupyOdbiorcow(this.recordData.id, this.form.value);
    } else {
      this.saveNazwaGrupyOdbiorcow(this.form.value);
    }
  };

  private saveNazwaGrupyOdbiorcow(data: StworzGrupeOdbiorcowRequest): void {
    this.grupyOdbiorcowService
      .saveGrupaOdbiorcow(data)
      .pipe(finalize(() => (this.isSaving = false)))
      .subscribe(() => {
        this.notificationService.showSaved();
        this.close();
      });
  }

  private updateNazwaGrupyOdbiorcow(grupaOdbiorcowId: string, data: EdytujGrupeOdbiorcowRequest): void {
    this.grupyOdbiorcowService
      .updateGrupaOdbiorcow(grupaOdbiorcowId, data)
      .pipe(finalize(() => (this.isSaving = false)))
      .subscribe(() => {
        this.notificationService.showUpdated();
        this.close();
      });
  }
}
